import React from 'react';
import './Event_about.css';
import close from '../../img/close.svg'
import img1 from '../../img/EventAbout/img1.png'
import img2 from '../../img/EventAbout/img2.png'
import img3 from '../../img/EventAbout/img3.png'
import img4 from '../../img/EventAbout/img4.png'
import check from '../../img/EventAbout/check.svg'

const Event_about_mob = () => {
    const state = {
        About_item: [
            [
                {
                    img: img2,
                    title: `Responsible AI and Social Good`,
                    descs: [
                        {
                            desc: `Foundations of Data Teams`,
                        },
                        {
                            desc: `Harnessing the enterprise to enable ML driven, hyper-personalised experiences`,
                        },
                        {
                            desc: `Building Advanced Analytics and Data Science Capabilities`,
                        },
                        {
                            desc: `Data Analytics with Kubernetes and OpenShift`,
                        },
                    ],
                },
            ],
            [
                {
                    img: img3,
                    title: `Data visualization tools and techniques`,
                    descs: [
                        {
                            desc: `Scalable AI (MLOps)`,
                        },
                        {
                            desc: `AI Ethics and Bias Federated Analytics`,
                        },
                        {
                            desc: `AI for Climate Change, Social Good Reproducibility`,
                        },
                        {
                            desc: `Explainable AI: heatmap-based explanations`,
                        },
                    ],
                },
            ],
            [
                {
                    img: img4,
                    title: `Big data analytics advantages and disadvantages`,
                    descs: [
                        {
                            desc: `Deciphering the Black Box: Latest Tools and Techniques for Interpretability`,
                        },
                        {
                            desc: `Adversarial Attacks on Deep Neural Networks`,
                        },
                        {
                            desc: `Integrating Pandas with Scikit-Learn, an Exciting New Workflow`,
                        },
                        {
                            desc: `Machine Learning for Digital Identity`,
                        },
                    ],
                },
            ],
        ],
    };

    const renderAboutDescs = (item, i) => {
        return (
            <div className='about_block' key={`about_block_mob--${i}`}>
                <div className='about_block--head'>
                    <div className='about_block--head_inner'>
                        <img className='about_block--title_img' src={item[0].img} alt="" />
                        <p className='about_block--title_text'>{item[0].title}</p>
                    </div>
                </div>
                <div className='about_block--desc_list'>
                    <ul className='about_block--desc_list_ul'>
                        {item[0].descs.map((item, index) => renderDescs(item, index))}
                    </ul>
                </div>
            </div>
        );
    };

    const renderDescs = (item, i) => {
        return (
            <React.Fragment key={`about_block--desc_list-child-${i}`}>
                <li className='about_block--desc_list-child'>
                    <img className='about_block--desc_list-child_img' src={check} alt="" />
                    <p className='about_block--desc_list-child_text'>{item['desc']}</p>
                </li>
            </React.Fragment>
        );
    };

    return (
        <div className="about_wrap about_wrap--mob">
            <div className="about container">
                <h2 className="about_title">What is this event about</h2>
                <div className="about_blocks">
                    {state.About_item.map((item, i) => renderAboutDescs(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about_mob;